/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["*[_ngcontent-%COMP%]{max-width:100%!important}nb-card[_ngcontent-%COMP%]{border-radius:12px;max-width:600px!important}nb-card-header[_ngcontent-%COMP%]{border-radius:12px;font-weight:600;font-size:18px}.icon-close[_ngcontent-%COMP%]{width:24px;height:24px;margin:auto;color:#474747;background:rgba(71,71,71,.1);border-radius:50%;padding:6px}"];
export { styles as styles };
